export default __webpack_public_path__ + "static/media/Info_Distribución_SIN_recaudo_Envío_Tradicional.879e7408.png";